module.exports = __webpack_public_path__ + "media/reference_check/images/success_page-2a3f439ad0f1d48668a0c90840d6d7d6.svg";